// extracted by mini-css-extract-plugin
export default {"mainTitle":"MobileSearchResults_mainTitle__as995","mainSearchResultContainer":"MobileSearchResults_mainSearchResultContainer__BS8r2"};